import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"

export const CreateTimerMutation = <T>(timer: T, callbacks?: Callbacks<T>) => {
    const { onSuccess, onError, onLoading } = useCallBack<any>(callbacks)

    const { postRequest } = useHttpRequest({})
    return async () => {
        const createTimer = async () => {
            try {
                const response = await postRequest(`${UrlConstant.Timer}/${UrlConstant.Create}`, timer)
                const data = await response
                return data
            } catch (error) {
                onError(error as Error)
            }
        }
        try {
            const res = await createTimer()
            if (res) {
                if (res.succeeded) onSuccess(res.message)
                else {
                    onSuccess(res.message)
                    onError(res.message);
                }
            }
        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
